import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { computed } from 'vue';
import { useStore } from 'vuex';
import SharePoster from './components/sharePoster/SharePoster.vue';
import ShareBtn from './components/shareBtn/ShareBtn.vue';
import { useLess } from '@/models/hooks';
export default {
  __name: 'ShareApp',
  props: {
    show: {
      type: Boolean,
      required: false
    },
    shareConfiguration: {
      type: Object,
      // Below props is initialized with default values at the beginning, and its attributes will be overridden with new values later.
      default() {
        return {
          asinInfo: {
            title: '',
            imageUrls: [
            // At that time, I felt that this product was quite attractive and was used as the default value
            'https://images-cn.ssl-images-amazon.cn/images/I/71k5P-4wjSL.jpg'],
            ourPrice: {
              amount: 206.14,
              currencyCode: 'CNY',
              type: 'DEAL'
            },
            merchant_badge: ''
          },
          shareUrl: '',
          type: 'wx_link' // ['wx_image', 'wx_link']
        };
      }
    }
  },

  emits: ['update:show'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('components/shareApp/ShareApp.less');
    const store = useStore();
    const isShowPopup = computed({
      get: () => props.show,
      set: val => {
        emit('update:show', val);
      }
    });
    const closeSharePopup = () => {
      store.commit('share/setPicListSelected', []);
      store.commit('share/setIsShowPoster', false);
      emit('update:show', false);
    };
    return (_ctx, _cache) => {
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        class: "share-pop",
        show: isShowPopup.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => isShowPopup.value = $event),
        position: "bottom",
        "close-on-click-overlay": false,
        onClickOverlay: closeSharePopup
      }, {
        "overlay-content": _withCtx(() => [_unref(store).state.share.isShowPoster ? (_openBlock(), _createBlock(SharePoster, {
          key: 0,
          shareConfiguration: __props.shareConfiguration
        }, null, 8, ["shareConfiguration"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(ShareBtn, {
          onCloseSharePopup: closeSharePopup,
          shareConfiguration: __props.shareConfiguration
        }, null, 8, ["shareConfiguration"])]),
        _: 1
      }, 8, ["show"]);
    };
  }
};